export class ReqBlacklist { 
    constructor({accountId, isDisabled=0, creatAt, disableAt}) {
        this.accountId = accountId
        this.isDisabled = isDisabled
        this.creatAt = creatAt
        this.disableAt = disableAt
    }

    fromJson(jsonDate) {
        this.accountId = jsonDate.accountId
        this.isDisabled = jsonDate.isDisabled
        this.creatAt = jsonDate.creatAt
        this.disableAt = jsonDate.disableAt
    }
}